export default {
  limit: 20,
};
